



























































































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { PlayErrorReasonEnum } from '@empathybroker/tsclient-play/dist/enums/play-error-reason.enum';
import { SynonymTypeConfig } from '@empathybroker/tsclient-play/dist/models/instance/synonym-type-config';
import { PlayErrorField } from '@empathybroker/tsclient-play/dist/models/play-error-field';
import { PlayErrorReason } from '@empathybroker/tsclient-play/dist/models/play-error-reason';
import { Synonym } from '@empathybroker/tsclient-play/dist/models/synonym';

import {
  CrudForm,
  RegularFilterSelector,
  SynonymsValues,
  Tabs,
  UiConfirm,
  UiIconButton,
  UiRadioGroup,
  UiTextbox
} from '../../components';

import { DeviceEnum, FilterIdEnum, KeyboardCodeEnum } from '../../enums';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

enum SynonymsTypes {
  SYNONYMS = 'synonyms',
  HYPONYMS = 'hyponyms'
}

export default {
  name: 'synonyms-form',
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    SynonymsValues,
    Tabs,
    UiIconButton,
    UiRadioGroup,
    UiTextbox,
    RegularFilterSelector,
    UiConfirm
  },
  computed: {
    valid: function (): boolean {
      if (!this.item.type) {
        return false;
      }
      if (!this.item.filters.lang) {
        return false;
      }
      if (!this.item.synonyms.length || (!this.item.hyponyms.length && (this.item.synonyms.length < 2))) {
        return false;
      }
      return true;
    },
    typeRadioGroupOptions: function (): any[] {
      const typeValuesMessages = this.messages.fields.type.values;
      return this.toolConfig.types.map((type: SynonymTypeConfig) => ({
        value: type.id,
        label: (type.prettyName || (!!typeValuesMessages && typeValuesMessages[type.id]) || type.id)
      }));
    },
    typeSelectedValue: function (): string {
      const selectedOption = this.typeRadioGroupOptions.find((option: any) => (option.value === this.item.type));
      return (!!selectedOption ? selectedOption.value : '');
    },
    isTypeVisible: function (): boolean {
      return this.toolConfig.types.length > 1;
    },
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config = { ...filters.lang.config, mandatory: true, multiselectDisabled: true };
      return filters;
    },
    isLangVisible: function (): boolean {
      return (this.context.filters[FilterIdEnum.LANG].config.values.length > 1);
    },
    inputGridClass: function (): string {
      return (this.$epb.device < DeviceEnum.SMALL_DESKTOP ? 'epb-grid-col-md-12' : 'epb-grid-col-md-4');
    },
    configurationTabs: function () {
      return Object.values(SynonymsTypes).map(type => ({
        id: type,
        text: this.messages.fields[type].label
      }));
    },
    serviceErrorsFieldsMapped: function (): any[] {
      return this.serviceErrorsFields.map((errorField: PlayErrorField) => {
        const errorFieldMapped: any = {
          ...errorField
        };
        if (!!errorField.conflictingElements) {
          const conflictingElements = [];
          Object.entries(errorField.conflictingElements).forEach(([fieldValue, synonyms]) => {
            const synonym = synonyms[0];
            const conflictingElement = conflictingElements.find((conflictingEl) => (conflictingEl.synonym.id === synonym.id));
            if (!conflictingElement) {
              conflictingElements.push({
                fieldValues: [fieldValue],
                synonym: synonym
              });
            } else {
              conflictingElement.fieldValues.push(fieldValue);
            }
          });
          errorFieldMapped.conflictingElements = conflictingElements;
        }
        return errorFieldMapped;
      });
    },
    isMobile: function (): boolean {
      return this.$epb.device <= DeviceEnum.MOBILE;
    }
  },
  data: function () {
    return {
      PlayErrorReasonEnum,
      dataType: ActionTypeEnum.SYNONYM,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.synonyms.update),
      item: {
        enabled: true,
        type: undefined,
        synonyms: [],
        hyponyms: [],
        filters: {
          lang: undefined
        }
      },
      DeviceEnum,
      SynonymsTypes,
      inputs: {
        synonyms: '',
        hyponyms: ''
      },
      messages: this.$epb.messages.tools.synonyms,
      help: {
        synonyms: this.$epb.messages.tools.synonyms.fields.synonyms.help,
        hyponyms: this.$epb.messages.tools.synonyms.fields.hyponyms.help
      },
      selectedTabId: SynonymsTypes.SYNONYMS,
      conflictIconButtonProps: {
        size: 'mini',
        type: 'secondary',
        color: 'primary'
      },
      conflictingSynonym: undefined
    };
  },
  methods: {
    onItemLoad: function (): void {
      CrudFormMixin.methods.onItemLoad.bind(this)();
      if (!this.item.type) {
        this.item.type = this.toolConfig.types[0].id;
      }
    },
    synonymsValuesProps: function (type: string) {
      return {
        [type]: this.item[type]
      };
    },
    onInputKeydown: function (keyboardEvent: KeyboardEvent, type: string) {
      if ((keyboardEvent.key === KeyboardCodeEnum.ENTER) || keyboardEvent.key === ';') {
        this.addValues(type);
        keyboardEvent.preventDefault();
      }
    },
    addValues: function (type: string) {
      const values: string[] = this.inputs[type].split(';');
      values.forEach((value: string) => {
        value = value.trim();
        if (!!value && this.item.synonyms.indexOf(value) < 0 && this.item.hyponyms.indexOf(value) < 0) {
          this.item[type].push(value);
          this.inputs[type] = '';
        }
      });
    },
    getConflictingSynonymText: function (synonym: Synonym): string {
      let synonymText = `"${ synonym.synonyms.join('", "') }"`;
      if (!!synonym.hyponyms.length) {
        synonymText += ` >> "${ synonym.hyponyms.join('", "') }"`;
      }
      return synonymText;
    },
    onDeleteConflict: function (synonym: Synonym): void {
      this.conflictingSynonym = synonym;
      this.$refs.deleteDialog.open();
    },
    onConfirmDeleteConflict: function (): void {
      CrudFormMixin.methods.onDeleteConflict.bind(this)(this.conflictingSynonym);
    },
    removeConflictFromErrorsFields: function (synonym: Synonym): void {
      const serviceErrorsFields = this.serviceErrorsFields.map((errorField: PlayErrorField) => {
        if (!!errorField.conflictingElements) {
          const conflictingElements = {};
          Object.entries(errorField.conflictingElements).forEach(([fieldValue, synonyms]) => {
            if (synonyms[0].id !== synonym.id) {
              conflictingElements[fieldValue] = synonyms;
            }
          });
          if (!Object.keys(conflictingElements).length) {
            errorField.reasons = errorField.reasons.filter((reason: PlayErrorReason) => reason.id !== PlayErrorReasonEnum.DUPLICATED);
          }
          errorField.conflictingElements = conflictingElements;
        }
        return errorField;
      });
      this.serviceErrorsFields = serviceErrorsFields.filter((errorField: PlayErrorField) => !!errorField.reasons.length);
    }
  }
};
